import { render, staticRenderFns } from "./EndEventDetail.vue?vue&type=template&id=5c31d322&"
import script from "./EndEventDetail.vue?vue&type=script&lang=js&"
export * from "./EndEventDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports